import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import {
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  Toggle,
  Flex,
  FormElement,
  Text
} from 'mailup-web-components'
import styled from '@emotion/styled'

import { modalCopyState } from '../recoil/state/modals'

const InputLists = () => {
  const intl = useIntl()

  const { lists, copyToLists, selectAll } = useRecoilValue(modalCopyState)

  const setModalCopyState = useSetRecoilState(modalCopyState)

  const handleChangeCopyToLists = selected => {
    setModalCopyState(prev => ({
      ...prev,
      copyToLists: selected
    }))
  }

  const handleToggleSelectAll = () => {
    setModalCopyState(({ selectAll, ...prev }) => ({
      ...prev,
      selectAll: !selectAll
    }))
  }

  const RightComponent = () => {
    return (
      <Flex columnGap='8px'>
        <Toggle
          variant='sm'
          checked={selectAll}
          onChange={handleToggleSelectAll}
          name='select-all'
          value='true'
        />

        <Text data-mu-test='input-select-all-true'>
          {intl.formatMessage({ id: 'Load.Bee.SelectAllLists' })}
        </Text>
      </Flex>
    )
  }

  return (
    <>
      <Flex width='100%' margin='24px 0'>
        <StyledFormElement
          label={intl.formatMessage({ id: 'Load.Bee.CopyTemplateToLists' })}
          required
          LabelRightComponent={RightComponent}
        >
          <Select
            variant={SELECT_VARIANT_WITH_CHECKBOX}
            multiple
            placeholder={intl.formatMessage({
              id: 'Load.Common.PlaceHolderSelectMultipleList'
            })}
            options={lists}
            value={copyToLists}
            onChange={handleChangeCopyToLists}
            disabled={selectAll}
          />
        </StyledFormElement>
      </Flex>
    </>
  )
}

export default InputLists

const StyledFormElement = styled(FormElement)`
  width: 100%;
`
